export const darkTheme = {
  primaryDark: '#0D0C1D',
  primaryLight: '#64327A',
  mobile: '576px',
};

export const lightTheme = {
  primaryDark: '#F0FFF0',
  primaryLight: '#FA5163',
  mobile: '576px',
};
